module.exports = __webpack_public_path__ + "static/media/components.1c528cc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/components.svg
// module id = 108
// module chunks = 1